import React from 'react';
import { Image, Menu, Tab, Button } from 'semantic-ui-react';
import { Form } from "formsy-semantic-ui-react";
import _ from "lodash";

const errorLabel = <div className="customErrorLabel" />;

class PlaybookIntegrationConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitButtonState: false,
            isDirty: false,
        };
    }

    updateStateValue() {
        this.setState({
            isDirty: true
        });
    }
    handleSubmit(data, configObj) {
        this.setState({
            isDirty: false
        });

        const configData = {
            type: configObj.id,
            integrationId: configObj._id,
            isUpdate: configObj.isDefinedForEntity,
            entityIntegrationConfigId: configObj.entityIntegrationConfigId,
            formData: JSON.parse(JSON.stringify(data))
        }
        this.props.onSave(configData);
    }

    render() {

        const props = this.props;
        const isDirty = this.state.isDirty;
        const thisObject = this;
        const getFormDataComponent = function (configObj) {

            let formDataComponent = null;

            if (configObj.formData && configObj.formData.length > 0) {
                formDataComponent = configObj.formData.map((int, index) => {

                    if (int.component == "text") {
                        return (
                            <Form.Input
                                required
                                key={index}
                                name={int.label}
                                label={_.startCase(int.label)}
                                onChange={event => thisObject.updateStateValue()}
                                placeholder={_.startCase(int.label)}
                                id={int.label}
                                value={int.value}
                            />
                        );
                    }

                    if (int.component == "textarea-json") {
                        return (
                            <Form.TextArea
                                required
                                key={index}
                                rows={20}
                                name={int.label}
                                label={_.startCase(int.label)}
                                onChange={event => thisObject.updateStateValue()}
                                placeholder={_.startCase(int.label)}
                                id={int.label}
                                value={int.value}
                                errorLabel={errorLabel}
                                validationError="Not a valid JSON"
                                instantValidation
                                validations={{
                                    isValidJSON: function (values, value) {
                                        if (value && value.trim() !== "") {
                                            try {
                                                JSON.parse(value);
                                            } catch (e) {
                                                return false;
                                            }
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }
                                }}
                            />
                        );
                    }

                });
            }

            return formDataComponent;
        }

        const panes = props.configData.map((configObj) => {
            return (
                {
                    menuItem: (
                        <Menu.Item key={configObj.id}>
                            <Image src={configObj.image} avatar />
                            <span>{configObj.label}</span>
                        </Menu.Item>
                    ),
                    render: () => <Tab.Pane>
                        <div>
                            <Form
                                noValidate
                                id="integrationPlaybookForm"
                                className="formcyForm"
                                ref="configForm"
                                onValidSubmit={data => thisObject.handleSubmit(data, configObj)}
                            >
                                {getFormDataComponent(configObj)}
                                <Button
                                    content="save"
                                    disabled={!(isDirty)}
                                    className="button-submit"
                                    type="submit"
                                />
                            </Form>
                        </div>
                    </Tab.Pane>
                }
            );
        })

        return (<Tab panes={panes} />);
    }
}

export default PlaybookIntegrationConfig;